module.exports = __webpack_public_path__ + "img/paper_airplane.53f3843c.png";